import { Component, OnInit } from '@angular/core';
import { MatSelect } from '@angular/material/select';
import { ActivatedRoute, Router } from '@angular/router';
import { TicketModel } from './ticket.model';
import { AccountsAndTaxesModel } from './accountsandtaxes.model';
import { TicketLineModel } from './ticketline.model';
import { TicketService } from './ticket.service';
import { BankAccountModel } from '../../finanzas/bancos/bankaccount.model';
import { BankAccountService } from '../../finanzas/bancos/bankaccount.service';
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { ActivityModel } from "../../user/activity/activity.model";
import { ActivityService } from "../../user/activity/activity.service";
import { CoreComponent } from '../../../core/header/core.component';
import * as FileSaver from 'file-saver';
import { Utils } from '../../../shared/utils';
import { ConceptModel } from '../../concept/concept/concept.model';
import { ConceptService } from '../../concept/concept/concept.service';

@Component({
    selector: 'convfact-ticket',
    templateUrl: './ticket.component.html',
    styleUrls: ['./ticket.component.css'],
    standalone: false
})

export class TicketComponent implements OnInit {
  ticket = new TicketModel;
  accountsAndTaxes = new AccountsAndTaxesModel;
  bankAccounts: BankAccountModel[] = [];
  errors = {};
  spinner: boolean = false;
  ready: boolean = false;
  activity: ActivityModel;

  submit(): void { }

  constructor(private ticketService: TicketService,
    private bankAccountService: BankAccountService,
    private activityService: ActivityService,
    private conceptService: ConceptService,
    private route: ActivatedRoute,
    private router: Router,
    public snackBar: MatSnackBar,
    private core: CoreComponent
  ) { }

  displayError(error: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10500;
    this.snackBar.open(error, '', options);
  }

  saveData = function (ticket: TicketModel) {
    this.ready = false;
    this.ticket.fiscalYear = this.core.yearSelected;
    this.ticket.activityUid = this.core.activitySelected;
    ticket.activityUid = this.core.activitySelected;
    this.activityService.loadData(this.core.activitySelected).then(response => {
      this.activity = response;
      this.activity.ticketNumber = ticket.ticketNumber;
    });

    if (ticket.uid == null) {
      this.ticketService.addData(ticket)
        .then(ticket => {
          this.spinner = true;

          this.generatePdf(ticket.uid);
          this.ticketService.saveRequestUpdateValue(false);

          //------------ Conceptos con números de serie ----------------//	
          this.ticketService.loadData(ticket.uid).then(invoice => {
            this.conceptService.getListSerialNumbers().then(conceptsWithSerialNumbers => {
              const concepts: ConceptModel[] = conceptsWithSerialNumbers;
              let conceptUid: string;
              if (concepts.length > 0) {
                concepts.forEach(concept => {
                  ticket.ticketLines.forEach(ticketLine => {
                    if (ticketLine.product.includes(concept.name)) {
                      console.log("Concepto con número de serie encontrado en factura");
                      conceptUid = concept.uid;
                      this.conceptService.getSerialNumbers(concept.uid).then(serialNumbers => {
                        serialNumbers.forEach(serialNumber => {
                          if (ticketLine.product.includes(serialNumber.serialNumber)) {
                            console.log("Número de serie encontrado en factura");
                            serialNumber.invoiceUid = ticket.uid;
                            serialNumber.invoiceNumber = ticket.ticketNumber;
                            this.conceptService.modifySerialNumbers(serialNumber, concept.uid).then(response => {
                              console.log("Número de serie actualizado");
                              this.conceptService.loadData(conceptUid).then(concept => {
                                concept.units = concept.units - 1;
                                this.conceptService.editData(conceptUid, concept).then(response => {
                                  console.log("Concepto actualizado");
                                });
                              });
                            });
                          }
                        });
                      });
                    }
                  });
                });
              }
            });
          });
          //------------ Fin Conceptos con números de serie ----------------//


          this.returnToIndex();
        })
        .catch(errors => {
          this.spinner = true;
          if (errors && errors.error && errors.error.message) {
            this.displayInfo(errors.error.message);
          } else {
            this.displayInfo('Compruebe los campos obligatorios marcados en rojo');
          }
          this.ticketService.saveRequestUpdateValue(false);
        })
    } else {
      this.ticketService.editData(ticket.uid, ticket)
        .then(ticket => {
          this.ticket = ticket;
          this.spinner = true;
          this.ticketService.saveRequestUpdateValue(false);
          this.returnToIndex();
        })
        .catch(errors => {
          this.spinner = true;
          if (errors && errors.error && errors.error.message) {
            this.displayInfo(errors.error.message);
          } else {
            this.displayInfo('Compruebe los campos obligatorios marcados en rojo');
          }
          this.ticketService.saveRequestUpdateValue(false);
        })
    }
  }

  ngOnInit() {
    this.ticket.ticketLines = new Array<TicketLineModel>();

    this.bankAccountService.getList().then(
      bankAccounts => {
        this.bankAccounts = bankAccounts.list;
      })

    this.spinner = false;
    this.route.params.subscribe(params => {
      const uid = params['uid'];
      this.spinner = true;
      if (uid != null) {
        this.ticketService.loadData(uid).then(ticket => {
          this.ticket = ticket;
          this.spinner = false;
          this.ready = true;
        })
      } else {
        this.ticket.ticketLines = new Array<TicketLineModel>();

        this.ticket.companyName = "";
        this.ticket.vatNumber = "";
        this.ticket.address = "";
        this.ticket.location = "";
        this.ticket.postalCode = "";
        this.ticket.state = "";
        this.ticket.country = "";

        this.activityService.loadData(this.core.activitySelected).then(response => {
          let loadActivity = new ActivityModel;
          loadActivity = response;
          this.ticket.ticketNumber = loadActivity.ticketNumber;
          this.spinner = false;
          this.ready = true;
        })
      }
    });

    this.ticketService.accountsAndTaxesData().then(accountsAndTaxes => {
      this.accountsAndTaxes = accountsAndTaxes;
    });
  }

  private generatePdf(uid: string) {
    this.ticketService.pdf(uid).then(response => {
      FileSaver.saveAs(response, Utils.GetPdfName("Ticket_" + this.ticket.ticketNumber));
    })
  }

  returnToIndex = function () {
    this.router.navigate(['invoice/ticket']);
  }
}
